import axios from "axios";
import {baseUrlBqFinalSale} from "../../config/api/apiConfig";

class BqApiService {
    private axios = axios.create({
        baseURL: baseUrlBqFinalSale,
        timeout: 5000000,
    });

    public async SendFinalSale(params?: any) {
        const queries = {
            ...(params?.dealerCode && {
                dealer_code: params.dealerCode,
            }),
            ...(params?.startDate && {
                date_start: params.startDate,
            }),
            ...(params?.endDate && {
                date_end: params.endDate,
            }),
            ...(params?.transferTitleStatus && {
                transfer_title_status: params.transferTitleStatus,
            }),
        }
        try {
            return await this.axios.get<any>('/order/final-sales', {
                headers: {
                    "X-Api-Key": "",
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e.response?.data?.error?.message ?? "Error");
        }
    }
}

export const bqApiService = new BqApiService();
